import { ResponseInterface } from '../../core';

export function mapValidateCredentialsResponse(response: ResponseInterface): void {
    if (response.errors) {
        throw response.errors;
    }
}
